export const STREAMLAIN_PANEL_SETTINGS_BUTTON_CLASS =
  'streamlain-panel-settings-button';

export const STREAMLAIN_PANEL_SETTINGS_BUTTON_STYLES = `
  .${STREAMLAIN_PANEL_SETTINGS_BUTTON_CLASS} svg {
    color: var(--streamlain-icon-secondary);
  }

  .${STREAMLAIN_PANEL_SETTINGS_BUTTON_CLASS}:hover svg,
  .${STREAMLAIN_PANEL_SETTINGS_BUTTON_CLASS}.active svg {
    color: var(--streamlain-icon-color);
  }
`;
